module.exports = __webpack_public_path__ + "static/img/Geos-2022-Adriana.fe3788d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Geos-2022-Adriana.png
// module id = ptQP
// module chunks = 0